<template>
  <div class="wrapper">
    <div class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          
          <div class="video-container">
              <video
                ref="videoPlayer"
                src="../../assets/img/test.mp4"
                controls
              ></video>
          
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoSrc: "", // chemin d'accès à la vidéo
    };
  },
  mounted() {
    this.$refs.videoPlayer.play(); // Lancer la lecture automatiquement au chargement de la page
  },
};
</script>
<style>
.video-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(
    100% - 20%
  ); /* Soustrait la hauteur de l'élément de navigation et la marge */
  margin: 0 5% 2% 5%; /* Ajoute des marges de 10px à gauche, droite et en bas */
  position: relative;
  z-index: 1;
}
h1 {
  margin-top: 0;
  font-size: 2rem;
}
video {
  max-width: 50%;
  max-height: 50%;
  margin-top:20%;
  
}
</style>
